import MainLayout from "../layouts/Mainlayout";

export default function GalleryMarquee() {
  return (
    <MainLayout>
      <h2 className="text-3xl font-bold text-center mb-6">Gallery 📸</h2>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {[1,2,3,4,5,6].map((i) => (
          <div
            key={i}
            className="h-40 rounded-xl bg-green-200"
          />
        ))}
      </div>
    </MainLayout>
  );
}